"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayChild = arrayChild;
exports.changedFormState = changedFormState;
exports.flatRootErrors = flatRootErrors;
exports.freshFormState = freshFormState;
exports.getExtras = getExtras;
exports.isExternallyValid = isExternallyValid;
exports.isValid = isValid;
exports.objectChild = objectChild;
exports.replaceArrayChild = replaceArrayChild;
exports.replaceObjectChild = replaceObjectChild;
exports.setExtrasBlurred = setExtrasBlurred;

var _shapedTree = require("./shapedTree");

var _types = require("./types");

var _array = require("./utils/array");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getExtras(formState) {
  return (0, _shapedTree.forgetShape)(formState[1]).data;
}

function freshFormState(value) {
  return [value, (0, _shapedTree.treeFromValue)(value, {
    errors: _types.cleanErrors,
    meta: _types.cleanMeta
  })];
}

function changedFormState(value) {
  return [value, (0, _shapedTree.treeFromValue)(value, {
    errors: _types.cleanErrors,
    meta: {
      blurred: true,
      touched: true,
      changed: true,
      succeeded: false,
      asyncValidationInFlight: false
    }
  })];
}

function flatRootErrors(formState) {
  var errors = (0, _shapedTree.getRootData)(formState[1]).errors;
  var flatErrors = [];

  if (errors.client !== "pending") {
    flatErrors = flatErrors.concat(errors.client);
  }

  if (errors.external !== "unchecked") {
    flatErrors = flatErrors.concat(errors.external);
  }

  return flatErrors;
}

function objectChild(key, formState) {
  var _formState = _slicedToArray(formState, 2),
      value = _formState[0],
      tree = _formState[1];

  return [value[key], (0, _shapedTree.shapedObjectChild)(key, tree)];
}

function arrayChild(index, formState) {
  var _formState2 = _slicedToArray(formState, 2),
      value = _formState2[0],
      tree = _formState2[1];

  return [value[index], (0, _shapedTree.shapedArrayChild)(index, tree)];
}

function setExtrasBlurred(_ref) {
  var errors = _ref.errors,
      meta = _ref.meta;
  return {
    errors: errors,
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      touched: true,
      blurred: true
    })
  };
}

function replaceObjectChild(key, child, formState) {
  var _formState3 = _slicedToArray(formState, 2),
      value = _formState3[0],
      tree = _formState3[1];

  var _child = _slicedToArray(child, 2),
      childValue = _child[0],
      childTree = _child[1];

  return [_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, key, childValue)), (0, _shapedTree.dangerouslyReplaceObjectChild)(key, childTree, tree)];
}

function replaceArrayChild(index, child, formState) {
  var _formState4 = _slicedToArray(formState, 2),
      value = _formState4[0],
      tree = _formState4[1];

  var _child2 = _slicedToArray(child, 2),
      childValue = _child2[0],
      childTree = _child2[1];

  return [(0, _array.replaceAt)(index, childValue, value), (0, _shapedTree.dangerouslyReplaceArrayChild)(index, childTree, tree)];
} // Is whole tree client valid?
// TODO(zach): This will have to change with asynchronous validations. We will
// need a "pending" value as well as an "unchecked" value.
// Currently, things in the tree which are not reflected in the React tree are
// marked "pending", which means they can be valid :grimace:.


function isValid(formState) {
  return (0, _shapedTree.foldMapShapedTree)(function (_ref2) {
    var client = _ref2.errors.client;
    return client === "pending" || client.length === 0;
  }, true, function (l, r) {
    return l && r;
  }, formState[1]);
}

function isExternallyValid(formState) {
  return (0, _shapedTree.foldMapShapedTree)(function (_ref3) {
    var external = _ref3.errors.external;
    return external === "unchecked" || external.length === 0;
  }, true, function (l, r) {
    return l && r;
  }, formState[1]);
}